"use client";

import * as React from "react";
import { motion } from "framer-motion";

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  x?: number;
  className?: string;
  /** Anima de novo ao reentrar na viewport */
  repeat?: boolean;
}

/** Aparece ao entrar na viewport (respeita prefers-reduced-motion via MotionConfig). */
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  x = 0,
  className,
  repeat = false,
}: RevealProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, x }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once: !repeat, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
